import React from 'react';

import PageSection from '@RHEnvironmental/pattern-library/dist/js/components/PageSection';
import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';

import MainLayout from '../../modules/MainLayout';

import navigator from '../../../services/ui/navigator';

import { isLoggedIn } from '../../../services/auth';

const NotFound = () => (
    <MainLayout centerContent>
        <PageSection className="page-section--fixed-width-container">
            <PageHeading level={1}>404</PageHeading>
            <p>Sorry the page you are looking for does not exist.</p>
            {isLoggedIn() ? (
                <Button onClick={() => navigator.push('/inspections')}>
                    Return to Dashboard
                </Button>
            ) : (
                <Button onClick={() => navigator.push('/sign-in')}>
                    Sign in
                </Button>
            )}
        </PageSection>
    </MainLayout>
);

export default NotFound;
